import React from "react";
import AdminSectionShell from "../components/AdminSectionShell";
import ViewDashboardOperacional from "../views/ViewDashboardOperacional";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const DashboardOperacional: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");

  if (isLoading) {
    return <p>Verificando permissão...</p>;
  }

  if (!isValid) {
    return null;
  }

  return (
    <AdminSectionShell backTo="/inicio">
      <ViewDashboardOperacional />
    </AdminSectionShell>
  );
};

export default DashboardOperacional;
